export const m = {
    voiceSearch: '语音检索',
    picSearch: '人像图片检索',
    faceSearch: '人像识别检索',
    hotWord: '热词：',
    more: '查看更多>',
    size: '大小：',
    share: '分享',
    fieldInfo: '场记信息',
    autoCata: '自动编目',
    videoSize: '视频尺寸',
    duration: '时长',
    codeRate: '码率',
    size: '大小',
    format: '格式',
    localUpload: '本地上传',
    similarCharacters: '相似人物：',
    reIdentification: '重新识别',
    sendQuickCode: '发起快编',
    videoDownload: '视频下载',
    interceptingClips: '截取片段',
    startTime: '开始时间',
    endTime: '结束时间',
    confirmInterception: '确认截取',
    interceptionTime: '截取时间',
    interceptNaming: '截取命名',
    submit: '提交',
    cancel: '取消',
    myVideo: '我的视频',
    transcoding: '转码中...',
    downLoad: '点击下载',
    save: '保存',
    relatedVideo: '相关视频',
    all: '全部',
    material: '素材',
    match: '赛事集锦/短视频',
    person: '自动人物集锦',
    project: '工程文件下载',
    date: '日期',
    classify: '分类',
    loadMore: '加载更多',
    hideMore: '收起更多',
    shoot: '拍摄',
    download2point5M: '低码视频下载',
    download25M: '源码视频下载',
    noCatalogue: '该视频暂无编目内容',
    nologkeeper: '该视频暂无场记信息',
    noReleateVideo: '暂无相关视频',
    noMyVideo: '暂无我的视频'
}
